import React, { useEffect, useState } from 'react';
import {
  MessageList,
  MessageInput,
  Thread,
  Window,
  useChannelActionContext,
  Avatar,
  useChannelStateContext,
  useChatContext,
} from 'stream-chat-react';
import starIcon from '../assets/star-icon.png';
import bellIcon from '../assets/bell-icon.png';
import reservationIcon from '../assets/reservation-icon.png';

import { ChannelInfo } from '../assets';

const ChannelInner = ({ setIsEditing }) => {
  const [giphyState, setGiphyState] = useState(false);
  const { sendMessage } = useChannelActionContext();

  const overrideSubmitHandler = (message) => {
    let updatedMessage = {
      attachments: message.attachments,
      mentioned_users: message.mentioned_users,
      parent_id: message.parent?.id,
      parent: message.parent,
      text: message.text,
    };

    if (giphyState) {
      updatedMessage = { ...updatedMessage, text: `/giphy ${message.text}` };
    }

    if (sendMessage) {
      sendMessage(updatedMessage);
      setGiphyState(false);
    }
  };

  const customActions = {
    'Copy text': (message) => {
      navigator.clipboard.writeText(message.text || '')
    },
  };

  return (
    <div style={{ display: 'flex', width: '100%' }}>
      <Window>
        <TeamChannelHeader setIsEditing={setIsEditing} />
        <MessageList messageActions={['edit', 'delete']} />
        <MessageInput overrideSubmitHandler={overrideSubmitHandler} grow={true} />
      </Window>
      {/*<Thread />*/}
    </div>
  );
};

const TeamChannelHeader = ({ setIsEditing }) => {
  const { channel, watcher_count } = useChannelStateContext();
  const { client } = useChatContext();
  const [isStarred, setIsStarred] = useState(channel?.data?.starred || false);
  const [isAttention, setIsAttention] = useState(channel?.data?.attention || false);
  const [bellTooltip, setBellTooltip] = useState(false);
  const [starTooltip, setStarTooltip] = useState(false);
  const [showIframe, setShowIframe] = useState(false); // New state for showing iframe

  const MessagingHeader = () => {
    const members = Object.values(channel.state.members).filter(
      ({ user }) => user.id !== client.userID && user.role === 'guest'
    );
    const additionalMembers = members.length - 3;

    if (channel.type === 'messaging') {
      return (
        <div className='team-channel-header__name-wrapper'>
          {members.map(({ user }, i) => (
            <div key={i} className='team-channel-header__name-multi'>
              <Avatar image={user.image} name={user.fullName || user.id} size={32} />
              <p className='team-channel-header__name user'>{user.fullName || user.id}</p>
            </div>
          ))}
          {/*{additionalMembers > 0 && <p className='team-channel-header__name user'>and {additionalMembers} more</p>}*/}
        </div>
      );
    }

    return (
      <div className='team-channel-header__channel-wrapper'>
        <p className='team-channel-header__name'># {channel.data.name}</p>
        <span style={{ display: 'flex' }} onClick={() => setIsEditing(true)}>
          <ChannelInfo />
        </span>
      </div>
    );
  };

  const getWatcherText = (watchers) => {
    if (!watchers) return 'No users online';
    if (watchers === 1) return '1 user online';
    return `${watchers} users online`;
  };

  useEffect(() => {
    // When the component mounts or the channel changes, update the starred state
    setIsStarred(channel?.data?.starred || false);
    setIsAttention(channel?.data?.attention || false);
  }, [channel]);

  const handleStarChannel = () => {
    try {
      channel.updatePartial({
        set: {
          starred: !isStarred,
        },
      });
      setIsStarred(prevIsStarred => !prevIsStarred); // Update the state immediately
    } catch (error) {
      console.error('Error toggling star for channel:', error);
    }
  };

  const handleAttentionChannel = () => {
    try {
      channel.updatePartial({
        set: {
          attention: !isAttention,
        },
      });
      setIsAttention(prevIsAttention => !prevIsAttention); // Update the state immediately
    } catch (error) {
      console.error('Error toggling attention for channel:', error);
    }
  };

  const handleReservationIconClick = () => {
    // Toggle the state to show/hide the iframe
    setShowIframe(!showIframe);
  };

  const starBackgroundClass = isStarred ? 'star-background-active' : 'star-background';
  const bellBackgroundClass = isAttention ? 'bell-background-active' : 'bell-background';

  return (
    <div className='team-channel-header__container'>
      <MessagingHeader />
      <div className='team-channel-header__right'>
        {/*<p className='team-channel-header__right-text'>{channel.data.last_message}</p>*/}
        <div
          className={starBackgroundClass}
          onClick={handleStarChannel}
          onMouseEnter={() => setStarTooltip(true)}
          onMouseLeave={() => setStarTooltip(false)}>
          <img
            src={starIcon}
            alt="Star Channel"
            className="star-icon"
          />
          {starTooltip && (
            <span className="tooltip">
              {isStarred ? "Remove from" : "Include in"} <strong>Starred Conversations</strong>
            </span>
          )}
        </div>
        <div
          className={bellBackgroundClass}
          onClick={handleAttentionChannel}
          onMouseEnter={() => setBellTooltip(true)}
          onMouseLeave={() => setBellTooltip(false)}>
          <img
            src={bellIcon}
            alt="Attention Needed"
            className="bell-icon"
          />
          {bellTooltip && (
            <span className="tooltip">
              Move to <strong>{isAttention ? "Replied" : "Attention Needed"}</strong>
            </span>
          )}
        </div>
        {/*}
        <div className="reservation-background" onClick={handleReservationIconClick}>
          <img
            src={reservationIcon}
            alt="Book Reservation"
            className="reservation-icon"
          />
        </div>
          */}
        {showIframe && (
          <iframe
            src="https://example.com"
            title="Reservation"
            className="reservation-iframe"
          />
        )}
        <p className='team-channel-header__right-text'>{getWatcherText(watcher_count)}</p>
      </div>
    </div>
  );
};

export default ChannelInner;


